import { call, put, takeEvery } from 'redux-saga/effects';
import api from '../../utils/api';
import { isNil } from 'lodash';
import { GET_WEBSITE_REQUEST, GET_WEBSITES_REQUEST } from '../constants';
import {
  getWebsiteStart,
  getWebsiteSuccess,
  getWebsiteFail,
  getWebsitesStart,
  getWebsitesSuccess,
  getWebsitesFail,
  setDealer,
} from '../actions/options';
import { setError, clearError } from '../actions/error';

export function* getWebsites(action) {
  try {
    yield put(getWebsitesStart());
    const websites = yield call(api.website.fetchAll, action.payload);
    yield put(getWebsitesSuccess(websites));
    yield put(clearError());
  } catch (error) {
    yield put(getWebsitesFail());
    yield put(setError(error));
  }
}

export function* getWebsite(action) {
  try {
    yield put(getWebsiteStart());
    const website = yield call(api.website.fetch, action.payload);
    const dealer = website?.dealer_id;
    if (!isNil(dealer)) {
      yield put(setDealer(dealer));
    } else {
      yield put(getWebsiteFail());
      yield put(setError(`No Dealer found for WebsiteId ${action.payload}`));
      return;
    }
    yield put(getWebsiteSuccess(website));
    yield put(clearError());
  } catch (error) {
    yield put(getWebsiteFail());
    yield put(setError(`Could Not Load WebsiteId ${action.payload}`));
  }
}

export function* optionsSaga() {
  yield takeEvery(GET_WEBSITES_REQUEST, getWebsites);
  yield takeEvery(GET_WEBSITE_REQUEST, getWebsite);
}
